export function ConvertParams(data, donId) {

  let dataGiaiQuyetDon = {...data};

  if (dataGiaiQuyetDon.truongDoanTTXMInfo) {
    dataGiaiQuyetDon.truongDoanTTXM = {
      id: dataGiaiQuyetDon.truongDoanTTXMInfo.congChucId
    }
  } else {
    dataGiaiQuyetDon.truongDoanTTXM = null;
  }

  // if (dataGiaiQuyetDon.canBoXuLyChiDinhInfo  && !dataGiaiQuyetDon.canBoXuLyChiDinh) {

  //   dataGiaiQuyetDon.canBoXuLyChiDinh ={
  //     id: dataGiaiQuyetDon.canBoXuLyChiDinhInfo.id
  //   }
  // } else {
  //   // dataGiaiQuyetDon.canBoXuLyChiDinh = null;
  // }

  // if (dataGiaiQuyetDon.phongBanGiaiQuyetInfo) {
  //   dataGiaiQuyetDon.phongBanGiaiQuyet ={
  //     id: dataGiaiQuyetDon.phongBanGiaiQuyetInfo.coQuanQuanLyId
  //   }
  // } else {
  //   dataGiaiQuyetDon.phongBanGiaiQuyet = null;
  // }

  // if (dataGiaiQuyetDon.nextStateInfo) {
  //   dataGiaiQuyetDon.nextState = {
  //     id: dataGiaiQuyetDon.nextStateInfo.id,
  //     type: dataGiaiQuyetDon.nextStateInfo.type
  //   }
  // } else {
  //   dataGiaiQuyetDon.nextState = null;
  // }

  if (dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo) {
    dataGiaiQuyetDon.donViGiaoThamTraXacMinh = {
      id: dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.coQuanQuanLyId
    }
  } else {
    dataGiaiQuyetDon.donViGiaoThamTraXacMinh = null;
  }

  if (dataGiaiQuyetDon.coQuanDaGiaiQuyetInfo) {
    dataGiaiQuyetDon.coQuanDaGiaiQuyet = {
      id: dataGiaiQuyetDon.coQuanDaGiaiQuyetInfo.coQuanQuanLyId
    }
  } else {
    dataGiaiQuyetDon.coQuanDaGiaiQuyet = null;
  }

  if (dataGiaiQuyetDon.donViThamTraXacMinhInfo) {
    dataGiaiQuyetDon.donViThamTraXacMinh = {
      id: dataGiaiQuyetDon.donViThamTraXacMinhInfo.coQuanQuanLyId
    }
  } else {
    dataGiaiQuyetDon.donViThamTraXacMinh = null;
  }

  if (dataGiaiQuyetDon.canBoGiaiQuyetInfo) {
    dataGiaiQuyetDon.canBoGiaiQuyet = {
      id: dataGiaiQuyetDon.canBoGiaiQuyetInfo.congChucId
    }
  } else {
    dataGiaiQuyetDon.canBoGiaiQuyet = null;
  }

  if (dataGiaiQuyetDon.canBoThamTraXacMinhInfo) {
    dataGiaiQuyetDon.canBoThamTraXacMinh = {
      id: dataGiaiQuyetDon.canBoThamTraXacMinhInfo.congChucId
    }
  } else {
    dataGiaiQuyetDon.canBoThamTraXacMinh = null;
  }

  if (dataGiaiQuyetDon.coQuanDieuTraInfo) {
    dataGiaiQuyetDon.coQuanDieuTra = {
      id: dataGiaiQuyetDon.coQuanDieuTraInfo.coQuanQuanLyId
    }
  } else {
    dataGiaiQuyetDon.coQuanDieuTra = null;
  }

  if (dataGiaiQuyetDon.donViTheoDoiThucHienInfo) {
    dataGiaiQuyetDon.donViTheoDoiThucHien = {
      id: dataGiaiQuyetDon.donViTheoDoiThucHienInfo.coQuanQuanLyId
    }
  } else {
    dataGiaiQuyetDon.donViTheoDoiThucHien = null;
  }

  if (dataGiaiQuyetDon.phongBanGiaiQuyetKetQuaXLDInfo) {
    dataGiaiQuyetDon.phongBanGiaiQuyetKetQuaXLD = {
      id: dataGiaiQuyetDon.phongBanGiaiQuyetKetQuaXLDInfo.coQuanQuanLyId
    }
  } else {
    dataGiaiQuyetDon.phongBanGiaiQuyetKetQuaXLD = null;
  }

  // if (dataGiaiQuyetDon.coQuanTheoDoiInfo) {
  //   dataGiaiQuyetDon.coQuanTheoDoi = {
  //     id: dataGiaiQuyetDon.coQuanTheoDoiInfo.coQuanQuanLyId
  //   }
  // } else {
  //   dataGiaiQuyetDon.coQuanTheoDoi = null;
  // }

  delete dataGiaiQuyetDon['_links'];
  delete dataGiaiQuyetDon['nguoiSuaInfo'];
  delete dataGiaiQuyetDon['nguoiTaoInfo'];
  delete dataGiaiQuyetDon['ngaySua'];
  delete dataGiaiQuyetDon['canBoXuLyChiDinhInfo'];
  delete dataGiaiQuyetDon['phongBanGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['ngayTao'];
  delete dataGiaiQuyetDon['donViThamTraXacMinhInfo'];
  delete dataGiaiQuyetDon['donViGiaoThamTraXacMinhInfo'];
  delete dataGiaiQuyetDon['phongBanGiaiQuyetKetQuaXLDInfo'];
  delete dataGiaiQuyetDon['canBoGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['nguoiBanHanhInfo'];
  delete dataGiaiQuyetDon['canBoThamTraXacMinhInfo'];
  delete dataGiaiQuyetDon['coQuanDieuTraInfo'];
  delete dataGiaiQuyetDon['donViTheoDoiThucHienInfo'];
  delete dataGiaiQuyetDon['huongXuLyGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['coQuanTheoDoiInfo'];
  delete dataGiaiQuyetDon['truongDoanTTXMInfo'];
  delete dataGiaiQuyetDon['nextStateInfo'];
  delete dataGiaiQuyetDon['coQuanDaGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['ketQuaXLDGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['donId'];

  dataGiaiQuyetDon.don = {
    id: Number(donId)
  }

  return dataGiaiQuyetDon;
}




// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/ParamsGiaiQuyetDon.jsx